const actions = {
  FETCH_DEVICES: 'FETCH_DEVICES',
  FETCH_DEVICES_SUCCESS: 'FETCH_DEVICES_SUCCESS',
  FETCH_DEVICES_ERROR: 'FETCH_DEVICES_ERROR',
  fetchDevices: (search) => ({
    type: actions.FETCH_DEVICES,
    search,
  }),
  fetchDevicesSuccess: (devices) => ({
    type: actions.FETCH_DEVICES_SUCCESS,
    devices
  }),

};
export default actions;
